<template>
  <div v-if="getRole('Consultar') || !allowAccess()">
    <table class="
            pt-2
            table table-sm table-responsive
            border-bottom
            max-w-full
            divide-y divide-gray-200
            table-striped
            rounded
            col-sm-12
          ">
      <thead class="table-active">
        <tr>
          <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-1
                ">
            ID
          </th>
          <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-8
                ">
            Documento
          </th>
          <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-4
                ">
            Fecha de subida
          </th>
          <th scope="col" class="
                  px-6
                  text-left text-xs
                  font-medium
                  text-gray-500
                  align-middle
                  mx-2
                  col-sm-2
                ">
            Evidencia
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr v-for="item in themes" :key="item.id">
          <td class="px-6 text-sm text-gray-500 mx-2">
            {{ item.id }}
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2">
            <b>
              Politica del SG SST
            </b>
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2">
            {{ dateConvert(item.created_at) }}
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center ">
            <button :id="`link${item.id}`" type="button"
              :class="item.link ? `btn btn-outline-primary btn-md` : `btn btn-secondary btn-md`"
              @click="print(item.link)" :disabled="!item.link || !allowAccess()">
              <i class="bx bx-download"></i>
            </button>
            <b-tooltip :target="`link${item.id}`">
              Descargar evidencia
            </b-tooltip>
          </td>
        </tr>
      </tbody>
    </table>
    <Pagination ref="paginator" :search="search" @fetch="(items) => (themes = items)" />
  </div>
</template>

<script>
import Pagination from "./PoliciesPagination";
import { dateFormat } from "@/utils/helpers/format"
import ItemAPI from "@/services/items/itemsAPI";
export default {
  components: { Pagination },
  props: {
    companyID: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      themes: [],
      search: null,

      itemData: null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(12)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date)
    },

    print(link) {
      if (link) {
        window.location.href = link;
      }
    },

     /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action 
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty
        
        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged
      
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

      /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page
    },

  },
  mounted() {
    
    this.getItemData();
  },
};
</script>
